import { CountryCode } from '~shared/constants';

export const BLOOMREACH_CAMPAIGN_IDS = {
  [CountryCode.Germany]: '64f71d6aaaec80bf6cda2a4f',
  [CountryCode.Spain]: '64f982c999005f907daa9f90',
  [CountryCode.Italy]: '64f9ef5e4b79b11dd558f279',
  [CountryCode.Portugal]: '64f9c634e23da2311c1ca4cc',
  [CountryCode.France]: '64fedacfa1c62613696b5e42',
  [CountryCode.Netherlands]: '64f9c5aca2d491ede4ffcc6f',
};
